import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@journal/env/environment';

@Injectable({
  providedIn: 'root'
})
export class CompetitionService {
  private baseUrl = `${environment.baseUrl}`;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`
   }
   
  getFilteredResults(disciplineId: string) {
    return this.http.get(this.baseUrl + 'competitions/active/?search=&disciplines=' + disciplineId +
    '&ordering=registration');
  }
}
